import QuestionModel from "../QuestionModel";
import QuestionModelChart from "../QuestionModelChart";
import QuestionValue from "../QuestionValue";
import QuestionValueGraphLabel from "../QuestionValueGraphLabel";
import QuestionValuePercentage from "../QuestionValuePercentage";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleStats extends QuestionModule {
    constructor() {
        super();
        this._answerType = null;
    }

    create(data) {

        let question;

        switch (data.type) {
            case QuestionModel.TYPE_STATS_VEN:
            case QuestionModel.TYPE_RATIO_PERCENT:
            case QuestionModel.TYPE_SUBTRACTION:
            case QuestionModel.TYPE_STATS_MIDDLE:
            case QuestionModel.TYPE_STATS_MOST_OFTEN:
            case QuestionModel.TYPE_STATS_SIMPLE_MEAN: {
                question = super.create(data);
                break;
            }
            default: {
                question = new QuestionModelChart(data.module, data.type, data.view, data.input, data.range);
                break;
            }
        }

        if (data.useWords !== undefined) question.useWords = data.useWords;
        if (data.answer_type) this._answerType = data.answer_type;
        if (data.bar_scale) question.barScale = data.bar_scale;
        this.generate(question, data.values);
        return question;
    }

    generate(question, total) {
        switch (question.type) {
            case QuestionModel.TYPE_STATS_VEN: {
                this.generateVen(question, total);
                break;
            }
            case QuestionModel.TYPE_STATS_LINE:
            case QuestionModel.TYPE_STATS_TALLY:
            case QuestionModel.TYPE_STATS_BAR: {
                this.generateBar(question, total);
                break;
            }
            case QuestionModel.TYPE_RATIO_PERCENT: {
                this.generatePercent(question, total);
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION: {
                this.generateSubtraction(question, total);
                break;
            }
            case QuestionModel.TYPE_STATS_SIMPLE_MEAN: {
                this.generateSimpleMean(question, total);
                break;
            }
            case QuestionModel.TYPE_STATS_MOST_OFTEN: {
                this.generateMostOften(question, total);
                break;
            }
            case QuestionModel.TYPE_STATS_MIDDLE: {
                this.generateMiddle(question, total);
                break;
            }
        }
    }

    generateVen(question, total) {
        //This Venn diagram shows the defenceitem held by a band of [elves].
        // How many of them only had swords? [12]
        if (total === 2) {
            //two ven diagrams
            let k = 100;
            const values = [];
            while (k-- > 0 && values.length < 3) {
                const randomValue = P3.math.randomInt(question.range.min, question.range.max);
                if (values.indexOf(randomValue) === -1) {
                    values.push(randomValue);
                }
            }

            const totalA = values[0];
            const totalB = values[1];

            const totalIntersection = values[2];

            question.values.push(new QuestionValue(totalA));
            question.values.push(new QuestionValue(totalB));
            question.values.push(new QuestionValue(totalIntersection));

            question.part = P3.math.randomInt(0, question.values.length - 1);//decide whether we are looking for val a, b or intersect

            const answer = question.answer;
            question.options.push(new QuestionValue(answer.value));

            question.labelIndexA = 0;
            question.labelIndexB = 1;

            k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                //const rand = P3.math.randomInt(question.range.min, question.range.max);
                const rand = P3.utils.selectRandom(question.values).value;
                if (arr.indexOf(rand) === -1 && rand !== answer.value) {
                    arr.push(rand);
                    question.options.push(new QuestionValue(rand));
                }
            }

            P3.utils.shuffleArray(question.options);

        } else if (total === 3) {
            //three ven diagrams
            let k = 100;
            const values = [];
            while (k-- > 0 && values.length < 7) {
                const randomValue = P3.math.randomInt(question.range.min, question.range.max);
                if (values.indexOf(randomValue) === -1) {
                    values.push(randomValue);
                }
            }
            const totalA = values[0];
            const totalB = values[1];
            const totalC = values[2];

            const totalIntersectionABC = values[3];
            const totalIntersectionAB = values[4];
            const totalIntersectionAC = values[5];
            const totalIntersectionBC = values[6];

            question.values.push(new QuestionValue(totalA));
            question.values.push(new QuestionValue(totalB));
            question.values.push(new QuestionValue(totalIntersectionAB));
            question.values.push(new QuestionValue(totalC));
            question.values.push(new QuestionValue(totalIntersectionABC));
            question.values.push(new QuestionValue(totalIntersectionAC));
            question.values.push(new QuestionValue(totalIntersectionBC));

            question.part = P3.math.randomInt(0, question.values.length - 1);//decide whether we are looking for val a, b, c or intersect

            const answer = question.answer;
            question.options.push(new QuestionValue(answer.value));

            question.labelIndexA = 0;
            question.labelIndexB = 1;
            question.labelIndexC = 3;

            k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                const rand = P3.utils.selectRandom(question.values).value;
                //const rand = P3.math.randomInt(question.range.min, question.range.max);
                if (arr.indexOf(rand) === -1 && rand !== answer.value) {
                    arr.push(rand);
                    question.options.push(new QuestionValue(rand));
                }
            }

            P3.utils.shuffleArray(question.options);
        }
    }

    generateBar(question, count) {
        //How many more [hobgoblins] are there than [wizards]?
        //first fill graph values with some random values
        let k = 1000;
        const valueArr = [];
        const rounding = count;
        while (k-- > 0 && valueArr.length < count) {
            const value = this._answerType !== QuestionModuleStats.TYPE_AVG ?
                P3.math.randomInt(question.range.min, question.range.max) :
                Math.round(P3.math.randomInt(question.range.min, question.range.max) / rounding) * rounding;
            if (value > 0 && value <= question.range.max && valueArr.indexOf(value) === -1) {
                valueArr.push(value);
                question.values.push(new QuestionValue(value));
            }
        }

        //difference
        const indexArr = [];

        k = 100;
        //find two random values that aren't same index
        while (k-- > 0 && indexArr.length < 2) {
            const randIndex = P3.math.randomInt(0, question.values.length - 1);
            if (indexArr.indexOf(randIndex) === -1) {
                indexArr.push(randIndex);
            }
        }

        const valueA = question.values[indexArr[0]];
        const valueB = question.values[indexArr[1]];

        const differenceAB = valueA - valueB;
        const differenceBA = valueB - valueA;

        question.labelIndexA = indexArr[0];
        question.labelIndexB = indexArr[1];

        const type = this._answerType;

        switch (type) {
            default: {
                console.error("unknown bar graph answer type : " + type);
            }
            case QuestionModuleStats.TYPE_READ: {
                question.answer = new QuestionValue(valueA);
                question.labelIndexA = indexArr[0];

                question.options.push(new QuestionValue(Math.abs(question.answer.value)));
                k = 100;
                let arr = [parseInt(question.options[0].value)];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(question.range.min, question.range.max - 1);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                P3.utils.shuffleArray(question.options);
                break;
            }
            case QuestionModuleStats.TYPE_DIFF_POS: {
                //pick whichever is positive
                //whether negative or positive doesn't matter, it just changes the copy, so absolute it here for comparisons
                if (differenceAB > 0) {
                    question.answer = new QuestionValue(Math.abs(differenceAB));
                    question.labelIndexA = indexArr[0];
                    question.labelIndexB = indexArr[1];
                } else {
                    question.answer = new QuestionValue(Math.abs(differenceBA));
                    question.labelIndexA = indexArr[1];
                    question.labelIndexB = indexArr[0];
                }


                question.options.push(new QuestionValue(Math.abs(question.answer.value)));
                k = 100;
                let arr = [parseInt(question.options[0].value)];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(question.range.min, question.range.max - 1);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                P3.utils.shuffleArray(question.options);
                break;
            }
            case QuestionModuleStats.TYPE_DIFF_NEG: {
                //pick whichever is negative
                if (differenceAB < 0) {
                    question.answer = new QuestionValue(Math.abs(differenceAB));
                    question.labelIndexA = indexArr[0];
                    question.labelIndexB = indexArr[1];
                } else {
                    question.answer = new QuestionValue(Math.abs(differenceBA));
                    question.labelIndexA = indexArr[1];
                    question.labelIndexB = indexArr[0];
                }

                question.options.push(new QuestionValue(Math.abs(question.answer.value)));
                k = 100;
                let arr = [parseInt(question.options[0].value)];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(question.range.min, question.range.max - 1);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                P3.utils.shuffleArray(question.options);
                break;
            }
            case QuestionModuleStats.TYPE_LOW: {
                //find lowest of all values
                let lowest = Number.POSITIVE_INFINITY, lowestIndex = -1;
                for (let i = 0; i < question.values.length; i++) {
                    if (question.values[i].value < lowest) {
                        lowest = question.values[i].value;
                        lowestIndex = i;
                    }
                }

                question.answer = new QuestionValueGraphLabel(lowest);
                question.answerIndex = lowestIndex;
                break;
            }
            case QuestionModuleStats.TYPE_HIGH: {
                //find lowest of all values
                let highest = Number.NEGATIVE_INFINITY, highestIndex = -1;
                for (let i = 0; i < question.values.length; i++) {
                    if (question.values[i].value > highest) {
                        highest = question.values[i].value;
                        highestIndex = i;
                    }
                }
                question.answer = new QuestionValueGraphLabel(highest);
                question.answerIndex = highestIndex;
                break;
            }
            case QuestionModuleStats.TYPE_AVG: {
                //find average of values
                let sum = 0;
                for (let i = 0; i < question.values.length; i++) {
                    sum += question.values[i].value;
                }
                const avg = sum / question.values.length;

                question.answer = new QuestionValue(avg);

                question.options.push(new QuestionValue(question.answer.value));
                k = 100;
                let arr = [parseInt(question.options[0].value)];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(question.range.min, question.range.max - 1);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                break;
            }
            case QuestionModuleStats.TYPE_RANGE: {
                //find range values
                const valueArrCopy = question.values.slice();

                valueArrCopy.sort((a, b) => {
                    return a.value - b.value;
                });

                const low = valueArrCopy[0].value;
                const high = valueArrCopy[valueArrCopy.length - 1].value;

                const range = high - low;

                question.answer = new QuestionValue(range);

                question.options.push(new QuestionValue(question.answer.value));
                k = 100;
                let arr = [parseInt(question.options[0].value)];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(question.range.min, question.range.max - 1);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                break;
            }
            case QuestionModuleStats.TYPE_SAME: {
                //A wise [elf]  made a tally to count how many [hobgoblins] [hid] [in the haystack]. On which two days did the same number of [hobgoblins] hide?
                //remove a value, then add in copy of another value
                question.values.pop();
                question.values.push(new QuestionValue(question.values[0].value));

                const sameValue = question.values[0].value;
                P3.utils.shuffleArray(question.values);

                //work out new indices of correct answers
                const ndxArr = [];
                for (let i = 0; i < question.values.length; i++) {
                    if (question.values[i].value === sameValue) {
                        ndxArr.push(i);
                    }
                }
                question.answerIndex = ndxArr;
                question.answer = new QuestionValueGraphLabel(-1);
                break;
            }
            case QuestionModuleStats.TYPE_EXACT: {
                const answerIndex = P3.math.randomInt(0, question.values.length - 1);
                const answerValue = question.values[answerIndex].value;

                question.answer = new QuestionValueGraphLabel(answerValue);
                question.answerIndex = answerIndex;
                break;
            }
            case QuestionModuleStats.TYPE_TOTAL: {
                //find total of values
                let sum = 0;
                for (let i = 0; i < question.values.length; i++) {
                    sum += question.values[i].value;
                }
                question.answer = new QuestionValue(sum);

                question.options.push(new QuestionValue(question.answer.value));
                k = 100;
                let arr = [sum];
                while (k-- > 0 && question.options.length < 5) {
                    const rand = P3.math.randomInt(sum - question.range.max, sum + question.range.max);
                    if (arr.indexOf(rand) === -1) {
                        arr.push(rand);
                        question.options.push(new QuestionValue(rand));
                    }
                }

                break;
            }
        }

        question.templateType = type;

    }

    generatePercent(question, count) {
        //You survey your army of 1,000 of [CHARACTERS]. 25% say attack now; 35% say seek peace; 16% say do nothing and the rest want to build a bigger army. How many want to build a bigger army?
        const a = P3.math.randomInt(15, 30);
        const b = P3.math.randomInt(15, 35);
        const c = P3.math.randomInt(15, 30);

        const restPercent = 100 - a - b - c;

        question.values.push(new QuestionValuePercentage(a, 100));
        question.values.push(new QuestionValuePercentage(b, 100));
        question.values.push(new QuestionValuePercentage(c, 100));

        const total = P3.math.randomInt(question.range.min, question.range.max);

        const answer = total * restPercent / 100;

        question.part = 3;

        question.values.push(new QuestionValue(answer));
        question.values.push(new QuestionValue(total));

        question.options.push(new QuestionValue(answer));

        let k = 100;
        const arr = [answer];
        while (k-- > 0 && question.options.length < count) {
            const rand = P3.math.randomInt(answer - 10, answer + 10);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }

        P3.utils.shuffleArray(question.options);
    }

    generateSubtraction(question, count) {
        //In a survey of weapons, 45 voted for the broadsword; 79 voted for the double-headed axe;
        //36 voted for the battle club; 64 voted for the mace and 54 voted for the spear.
        //How many more voted for the axe than the battle club?

        //first just generate a list of unique values
        let k = 100;
        const arr = [];
        while (k-- > 0 && question.values.length < count) {
            const rand = P3.math.randomInt(question.range.min, question.range.max);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.values.push(new QuestionValue(rand));
            }
        }

        question.values.sort((a, b) => {
            return b.value - a.value;
        });

        const high = question.values[0];
        const low = question.values[question.values.length - 1];

        const diff = high.value - low.value;

        question.values.shift();//remove head
        question.values.pop();//remove tail

        P3.utils.shuffleArray(question.values);//then shuffle

        question.values.unshift(high);//add head and tail back in
        question.values.push(low);

        question.values.push(new QuestionValue(diff));
        question.part = question.values.length - 1;

        question.options.push(new QuestionValue(diff));

        k = 100;
        const arrOptions = [diff];
        while (k-- > 0 && question.options.length < 5) {
            const rand = P3.math.randomInt(diff - 10, diff + 10);
            if (arrOptions.indexOf(rand) === -1) {
                arrOptions.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }
        P3.utils.shuffleArray(question.options);
    }

    generateSimpleMean(question, count) {
        //What is [NUM1] + [NUM2] + [NUM3] + [NUM4] + [NUM5] ÷ 5?

        let sum = 0;

        //first lets fill values with some random numbers in range
        let k = 100;
        const arr = [];
        while (k-- > 0 && question.values.length < count) {
            //ensure we get whole division when we divide by count
            //   const rand = Math.round(P3.math.randomInt(question.range.min, question.range.max) / count) * count;
            const rand = P3.math.randomInt(question.range.min, question.range.max);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.values.push(new QuestionValue(rand));
                sum += rand;
            }
        }

        //add count to end of values
        question.values.push(new QuestionValue(count));

        //add result to values
        const result = sum / count;

        question.values.push(new QuestionValue(result));
        question.part = question.values.length - 1;

        //add result to options
        question.options.push(new QuestionValue(result));

        //generate options
        k = 100;
        const arrOptions = [result];
        while (k-- > 0 && question.options.length < 5) {
            const rand = Math.round(P3.math.randomInt(question.range.min, question.range.max) / count) * count;
            if (arrOptions.indexOf(rand) === -1) {
                arrOptions.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }
        P3.utils.shuffleArray(question.options);
    }

    generateMostOften(question, count) {
        //Select the numbers that appear most often in this list?

        //pick total large same and small same, then pick values
        const largeSameTotal = Math.ceil((count) * 0.5);
        const smallSameTotal = largeSameTotal - 1;

        const largeSameValue = P3.math.randomInt(question.range.min, question.range.max);

        //make sure they aren't the same number
        let smallSameValue = largeSameValue;
        let k = 100;
        while (k-- > 0 && smallSameValue === largeSameValue) {
            smallSameValue = P3.math.randomInt(question.range.min, question.range.max);
        }

        for (let i = 0; i < largeSameTotal; i++) {
            question.values.push(new QuestionValue(largeSameValue));
        }

        for (let i = 0; i < smallSameTotal; i++) {
            question.values.push(new QuestionValue(smallSameValue));
        }

        P3.utils.shuffleArray(question.values);
        question.options = question.values.slice();

        //add right at the end the sum of the highest, so we can compare to the user input answer
        const answer = largeSameTotal * largeSameValue;
        question.values.push(new QuestionValue(answer));
        question.part = question.values.length - 1;
    }

    generateMiddle(question, count) {
        let k = 100;
        const arr = [];
        while (k-- > 0 && question.values.length < count)
        {
            const r = P3.math.randomInt(question.range.min, question.range.max);
            if (arr.indexOf(r) === -1)
            {
                arr.push(r);
                question.values.push(new QuestionValue(r));
            }
        }

        question.options = question.values.slice();
        question.values.sort((x, y) => { return y.value - x.value; });
        question.part = Math.floor(question.values.length * 0.5);
    }
}

QuestionModuleStats.TYPE_READ = "read_value";
QuestionModuleStats.TYPE_DIFF_POS = "difference_positive";
QuestionModuleStats.TYPE_DIFF_NEG = "difference_negative";
QuestionModuleStats.TYPE_LOW = "lowest";
QuestionModuleStats.TYPE_HIGH = "highest";
QuestionModuleStats.TYPE_AVG = "average";
QuestionModuleStats.TYPE_RANGE = "range";
QuestionModuleStats.TYPE_SAME = "same";
QuestionModuleStats.TYPE_EXACT = "exact";
QuestionModuleStats.TYPE_TOTAL = "total";